import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { toggleEventPreviewMode } from "../../../../../../store/actions/admin/create-event";
import { useTypedSelector } from "../../../../../../store/reducers/use-typed-selector";
import ModalComponent from "../../../../../general-ui/modal/modal";
import LiveEventDocumentHead from "../../../../../live-event/live-event-document-head";
import MarketingPage from "../../../../../live-event/marketing-page/marketing-page";
import './event-preview.scss';
import className from 'classnames';
import { useParams } from "react-router";
import { ParamsProps } from "../../../../../live-event/live-event";

interface LandingPreviewProps {
	open: boolean;
}

const LandingPreviewModal: React.FC<LandingPreviewProps> = ({ open }) => {
	const {
		workingEvent,
		editorSize
	} = useTypedSelector(state => ({
		workingEvent: state.CreateEventReducer.workingEvent,
		editorSize: state.CreateEventReducer.editorSize
	}));

	const dispatch = useDispatch();

	const { language } = useParams() as ParamsProps;

	const modalBody = useMemo(() => {
		return workingEvent && (
			<div className={className("event-preview-wrapper live-event-container", editorSize)}>
				<LiveEventDocumentHead eventBundle={workingEvent} />
				<MarketingPage previewEventBundle={workingEvent!} previewLanguage={language || "en"} />
			</div>
		);
	}, [workingEvent, editorSize, language]);

	const closeModal = useCallback(() => {
		dispatch(toggleEventPreviewMode(null));
	}, [dispatch]);

	return (
		<div className="preview-modal">
			<ModalComponent
				open={open}
				onRequestClose={closeModal}
				cancellable={false}
				closeable={true}
				size={editorSize}
				eventPreview
			>
				{modalBody}
			</ModalComponent>
		</div>
	);
};

export default LandingPreviewModal;